"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Standardized values for relationship `_class`.
 */
var RelationshipClass;
(function (RelationshipClass) {
    /**
     * A relationship between an {AccessPolicy, Firewall} and a resource Entity.
     */
    RelationshipClass["ALLOWS"] = "ALLOWS";
    /**
     * A relationship between a User and a PR.
     */
    RelationshipClass["APPROVED"] = "APPROVED";
    /**
     * A relationship between a {AccessRole, User, Group} and AccessPolicy.
     */
    RelationshipClass["ASSIGNED"] = "ASSIGNED";
    RelationshipClass["CONNECTS"] = "CONNECTS";
    /**
     * A relationship indicating an Entity contains another Entity.
     *
     * Examples:
     *
     * - Network - CONTAINS -> Network (a subnet)
     * - Network - CONTAINS -> Host
     * - Cluster - CONTAINS -> Host
     * - UserGroup - CONTAINS -> User
     *
     * @see HAS
     */
    RelationshipClass["CONTAINS"] = "CONTAINS";
    /**
     * A relationship between a User and any Entity.
     */
    RelationshipClass["CREATED"] = "CREATED";
    /**
     * A relationship between a CodeRepo and Function.
     */
    RelationshipClass["DEFINES"] = "DEFINES";
    /**
     * A relationship between an {AccessPolicy, Firewall} and a resource Entity.
     */
    RelationshipClass["DENIES"] = "DENIES";
    RelationshipClass["DEPLOYED"] = "DEPLOYED";
    /**
     * A relationship between a {Vulnerability, Finding} and Weakness.
     */
    RelationshipClass["EXPLOITS"] = "EXPLOITS";
    RelationshipClass["EXTENDS"] = "EXTENDS";
    /**
     * A relationship indicating an Entity is responsible for generating another Entity.
     *
     * Examples:
     *
     * * Project - GENERATED -> Finding
     */
    RelationshipClass["GENERATED"] = "GENERATED";
    /**
     * A relationship indicating a possessive association between two Entities.
     * The direction of the relationship typically flows toward the possessed
     * Entity.
     *
     * Examples:
     *
     * - Account - HAS -> User
     * - Network - HAS -> AccessPolicy
     * - Network - HAS -> Firewall
     * - Finding - HAS -> ThreatIntel
     *
     * @see CONTAINS
     */
    RelationshipClass["HAS"] = "HAS";
    /**
     * A relationship indicating an Entity identified another Entity.
     *
     * Examples:
     *
     * * Service - IDENTIFIED -> Finding
     */
    RelationshipClass["IDENTIFIED"] = "IDENTIFIED";
    RelationshipClass["IMPLEMENTS"] = "IMPLEMENTS";
    /**
     * A relationship indicating an Entity is an instance of another Entity.
     *
     * Examples:
     *
     * * Finding - IS -> Vulnerability
     * * User - IS -> Person
     */
    RelationshipClass["IS"] = "IS";
    RelationshipClass["MANAGES"] = "MANAGES";
    RelationshipClass["MITIGATES"] = "MITIGATES";
    RelationshipClass["MONITORS"] = "MONITORS";
    RelationshipClass["OPENED"] = "OPENED";
    RelationshipClass["OWNS"] = "OWNS";
    RelationshipClass["PERFORMED"] = "PERFORMED";
    RelationshipClass["PROTECTS"] = "PROTECTS";
    RelationshipClass["PROVIDES"] = "PROVIDES";
    /**
     * A relationships indicating an Entity performs some kind of scan on another Entity.
     *
     * Examples:
     *
     * * Service - SCANS -> Host
     */
    RelationshipClass["SCANS"] = "SCANS";
    RelationshipClass["TRIGGERS"] = "TRIGGERS";
    RelationshipClass["TRUSTS"] = "TRUSTS";
    /**
     * A relationship between a User and any Entity.
     */
    RelationshipClass["UPDATED"] = "UPDATED";
    /**
     * A relationship indicating an Entity utilizes another Entity. Typically, the
     * target Entity can be "used" by many source Entities.
     *
     * Examples:
     *
     * * Host - USES -> DataStore
     * * UserRole - USES -> AccessPolicy
     */
    RelationshipClass["USES"] = "USES";
    /**
     * A relationship indicating that a device has some kind of application
     * installed.
     *
     * Examples:
     *
     * Device - INSTALLED -> Application
     */
    RelationshipClass["INSTALLED"] = "INSTALLED";
})(RelationshipClass = exports.RelationshipClass || (exports.RelationshipClass = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVsYXRpb25zaGlwQ2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvUmVsYXRpb25zaGlwQ2xhc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQTs7R0FFRztBQUNILElBQVksaUJBbUpYO0FBbkpELFdBQVksaUJBQWlCO0lBQzNCOztPQUVHO0lBQ0gsc0NBQWlCLENBQUE7SUFFakI7O09BRUc7SUFDSCwwQ0FBcUIsQ0FBQTtJQUVyQjs7T0FFRztJQUNILDBDQUFxQixDQUFBO0lBQ3JCLDBDQUFxQixDQUFBO0lBRXJCOzs7Ozs7Ozs7OztPQVdHO0lBQ0gsMENBQXFCLENBQUE7SUFFckI7O09BRUc7SUFDSCx3Q0FBbUIsQ0FBQTtJQUVuQjs7T0FFRztJQUNILHdDQUFtQixDQUFBO0lBRW5COztPQUVHO0lBQ0gsc0NBQWlCLENBQUE7SUFFakIsMENBQXFCLENBQUE7SUFFckI7O09BRUc7SUFDSCwwQ0FBcUIsQ0FBQTtJQUVyQix3Q0FBbUIsQ0FBQTtJQUVuQjs7Ozs7O09BTUc7SUFDSCw0Q0FBdUIsQ0FBQTtJQUV2Qjs7Ozs7Ozs7Ozs7OztPQWFHO0lBQ0gsZ0NBQVcsQ0FBQTtJQUVYOzs7Ozs7T0FNRztJQUNILDhDQUF5QixDQUFBO0lBRXpCLDhDQUF5QixDQUFBO0lBRXpCOzs7Ozs7O09BT0c7SUFDSCw4QkFBUyxDQUFBO0lBRVQsd0NBQW1CLENBQUE7SUFDbkIsNENBQXVCLENBQUE7SUFDdkIsMENBQXFCLENBQUE7SUFDckIsc0NBQWlCLENBQUE7SUFDakIsa0NBQWEsQ0FBQTtJQUNiLDRDQUF1QixDQUFBO0lBQ3ZCLDBDQUFxQixDQUFBO0lBQ3JCLDBDQUFxQixDQUFBO0lBRXJCOzs7Ozs7T0FNRztJQUNILG9DQUFlLENBQUE7SUFFZiwwQ0FBcUIsQ0FBQTtJQUNyQixzQ0FBaUIsQ0FBQTtJQUVqQjs7T0FFRztJQUNILHdDQUFtQixDQUFBO0lBRW5COzs7Ozs7OztPQVFHO0lBQ0gsa0NBQWEsQ0FBQTtJQUViOzs7Ozs7O09BT0c7SUFDSCw0Q0FBdUIsQ0FBQTtBQUN6QixDQUFDLEVBbkpXLGlCQUFpQixHQUFqQix5QkFBaUIsS0FBakIseUJBQWlCLFFBbUo1QiJ9